const html = require('choo/html');
const Component = require('choo/component');
const Account = require('./account');
const LanguageSwitch = require('./languageSwitch');
const { nanohtmlCreatesDomNodes } = require('./nanohtmlEnv');
const { buildKunqiongHeaderHtml } = require('../../common/kunqiongChromeHtml');

class Header extends Component {
  constructor(name, state, emit) {
    super(name);
    this.state = state;
    this.emit = emit;
    this.account = state.cache(Account, 'account');
    this.languageSwitch = state.cache(LanguageSwitch, 'languageSwitch');
  }

  update() {
    if (this.locale !== this.state.locale) {
      this.locale = this.state.locale;
      return true;
    }
    this.account.render();
    this.languageSwitch.render();
    return false;
  }

  createElement() {
    const toolbarClass =
      'flex flex-row flex-wrap items-center justify-end gap-3 w-full px-4 md:px-8 py-2 bg-grey-10 dark:bg-grey-90 border-b border-grey-20 dark:border-grey-80';
    const lang = this.languageSwitch.render();
    const acct = this.account.render();
    const t = id => this.state.translate(id);
    const kunqiongHeadMarkup = buildKunqiongHeaderHtml(t);

    if (nanohtmlCreatesDomNodes()) {
      const root = html`
        <div class="kq-chrome-header w-full flex-none flex flex-col">
          <div class="kq-head-slot"></div>
          <div class="${toolbarClass}">${lang} ${acct}</div>
        </div>
      `;
      const slots = root.getElementsByClassName('kq-head-slot');
      const slot = slots[0];
      if (slot) {
        slot.innerHTML = kunqiongHeadMarkup;
      }
      return root;
    }

    return html`
      <div class="kq-chrome-header w-full flex-none flex flex-col">
        <div class="kq-head-slot">${{ outerHTML: kunqiongHeadMarkup }}</div>
        <div class="${toolbarClass}">${lang} ${acct}</div>
      </div>
    `;
  }
}

module.exports = Header;
